import { css } from "styled-components";

import { rydeColors } from "../parts";

export const utilityClassesStyles = css`
  .pointer {
    cursor: pointer;
  }

  .truncate-text {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .flexCenterVertical {
    display: flex;
    align-items: center;
  }

  .highlight {
    background-color: ${rydeColors.highlightSearch};
    padding: 1px 2px;
    border-radius: 2px;
  }

  .search-highlight {
    background-color: ${rydeColors.highlightSearch};
    padding: 1px 2px;
    border-radius: 2px;
    font-weight: 500;
  }

  .displayNone {
    display: none !important;
  }

  .break-word {
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-all;
  }
`;
